import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["dataTestId", "disabled", "disableSearch", "targetRef", "ariaLabel", "dataHjAllow", "value", "onClick", "onClear", "options", "searchValue", "onSearch"];
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { Input } from "@faire/web--source/slate/Input";
import * as React from "react";
import { DropdownChevron } from "./DropdownChevron";
export var DropdownInput = function DropdownInput(_ref) {
  var dataTestId = _ref.dataTestId,
    disabled = _ref.disabled,
    disableSearch = _ref.disableSearch,
    targetRef = _ref.targetRef,
    ariaLabel = _ref.ariaLabel,
    dataHjAllow = _ref.dataHjAllow,
    value = _ref.value,
    onClick = _ref.onClick,
    onClear = _ref.onClear,
    options = _ref.options,
    searchValue = _ref.searchValue,
    onSearch = _ref.onSearch,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleChange = React.useCallback(function (e) {
    if (!disableSearch) {
      onSearch(e);
    }
  }, [disableSearch, onSearch]);
  var selectedLabel = React.useMemo(function () {
    var _options$find;
    return (_options$find = options.find(function (o) {
      return o.value === value;
    })) === null || _options$find === void 0 ? void 0 : _options$find.label;
  }, [options, value]);
  var handleClick = React.useCallback(function (e) {
    onClick === null || onClick === void 0 ? void 0 : onClick();
    e.preventDefault();
    e.stopPropagation();
  }, [onClick]);
  var displayValue = React.useMemo(function () {
    var _ref2;
    return disableSearch ? selectedLabel !== null && selectedLabel !== void 0 ? selectedLabel : "" : (_ref2 = searchValue !== null && searchValue !== void 0 ? searchValue : selectedLabel) !== null && _ref2 !== void 0 ? _ref2 : "";
  }, [disableSearch, selectedLabel, searchValue]);
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    "data-test-id": dataTestId,
    disabled: disabled,
    value: displayValue,
    inputMode: disableSearch ? "none" : undefined,
    onChange: handleChange,
    style: {
      width: "100%"
    },
    suffixNode: /*#__PURE__*/React.createElement(DropdownChevron, {
      value: value,
      onClear: onClear,
      disabled: disabled
    }),
    ref: targetRef,
    spellCheck: !disableSearch,
    "aria-label": ariaLabel,
    "data-hj-allow": dataHjAllow,
    hideCharacterCount: true,
    onClick: handleClick
  }));
};